export default "__VITE_ASSET__DPT8AmfU__"